// extracted by mini-css-extract-plugin
export var wrap = "index-module--wrap--1msyj";
export var title = "index-module--title--1_Kue";
export var animationBrand = "index-module--animationBrand--2dop4";
export var mail = "index-module--mail--3jbMq";